module.exports = __webpack_public_path__ + "static/media/8.1.3.3.yandex_alisa_napominanie.37642002.png";